const normalizeBase = (value) => value.endsWith('/') ? value : `${value}/`;

const server = process.env.REACT_APP_REPORTS_SERVER || '/';

export const URL = process.env.REACT_APP_REPORTS_API_BASE || `${normalizeBase(server)}netcoreportsweb/`;

export const clientID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '639259440064-34u3cv190ciprrr6eg4l9krb1mei6uoq.apps.googleusercontent.com';
